module.exports = __webpack_public_path__ + "img/Step finance.472d3c97.svg";